// extracted by mini-css-extract-plugin
export default {"registerModal":"RegisterModal_registerModal__Q0R6w","header":"RegisterModal_header__G6lTE","body":"RegisterModal_body__fZceb","footer":"RegisterModal_footer__F9ENQ"};